import * as React from "react";
import styled, { css } from "styled-components";

import Grid from "src/library/components/Hedron";
import { BrandSplitView } from "src/library/components/BrandSplitView";
import { Button } from "src/library/components/Button";
import { Text } from "src/library/components/Text";
import { Logo } from "src/core/shared/components/Logo";
import { PageProps } from "src/pages/Router/routes";

/**
 * 403 No Access / Forbidden View
 *
 * @param {*} { history }
 * @returns
 */
const GenericError: React.ReactFCWithChildren<PageProps<unknown>> = () => {
  return (
    <BrandSplitView>
      <GenericErrorInner>
        <Grid.Box className="logo-wrapper">
          <Logo type="dark" />
        </Grid.Box>

        <PaddedContainer>
          <Text
            weight="bold"
            letterSpacing="big"
            fontSize="h1"
          >
            Error
          </Text>
        </PaddedContainer>

        <PaddedContainer>
          <Text
            color="secondary"
            fontSize="p"
            style={{
              display: "inline-block",
              textAlign: "center"
            }}
          >
            Something went wrong.
            {" "}

            <br />
            If this problem continues, please contact an administrator.
          </Text>
        </PaddedContainer>

        <PaddedContainer>
          <Button onClick={() => history.back()}>
            Go back
          </Button>
        </PaddedContainer>
      </GenericErrorInner>
    </BrandSplitView>
  );
};

const PaddedContainer = styled(Grid.Box)`
  ${({ theme }) =>
    css`
      padding-top: ${theme.spacing.padding.xl};
    `};
`;

const GenericErrorInner = styled(Grid.Bounds)`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  width: 100%;
  height: 100%;
  ${({ theme }) =>
    css`
      padding: ${theme.spacing.padding.xl};
      padding-bottom: 0;
  `};

  .logo-wrapper {
    max-width: 400px;
  }
`;

export default GenericError;
